import {authHeader, determineAPIHost} from '../../lib/api';
import {validateHost, validatePath} from '../../lib/api-host-whitelist';

export default async function fetchContent(file: string, signal: AbortSignal): Promise<string> {
    const host = determineAPIHost();
    const path = '/v2/stream/document/' + file;
    const headers = await authHeader();

    try {
        // Validate host and path separately for security
        const validatedHost = validateHost(host);
        const validatedPath = validatePath(path);
        const validatedUrl = validatedHost + validatedPath;

        const response = await fetch(validatedUrl, {
            method: 'GET',
            signal,
            headers
        });

        if (!response.ok) {
            // Don't include headers or full response in error message to prevent sensitive data leakage
            throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);
        }

        return await response.text();
    } catch (error) {
        // Ensure sensitive headers are not exposed in error messages
        if (error instanceof Error) {
            throw new Error(`Content fetch failed: ${error.message}`);
        }
        throw new Error('Content fetch failed: Unknown error');
    }
}